var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
    fill: "#9D480A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16256 6.99178C5.93076 6.99178 5.73853 6.79956 5.73853 6.56776V6.44906C5.73853 5.79324 6.21908 5.47097 6.4 5.34659C6.60918 5.20525 6.67702 5.10914 6.67702 4.96215C6.67702 4.67947 6.44524 4.44765 6.16256 4.44765C5.87987 4.44765 5.64809 4.67947 5.64809 4.96215C5.64809 5.19395 5.45587 5.38617 5.22407 5.38617C4.99227 5.38617 4.80005 5.19395 4.80005 4.96215C4.80005 4.21022 5.41062 3.59961 6.16256 3.59961C6.91449 3.59961 7.52506 4.21022 7.52506 4.96215C7.52506 5.60666 7.05018 5.92891 6.87492 6.04764C6.65443 6.19463 6.58658 6.29075 6.58658 6.44906V6.56776C6.58658 6.80521 6.39435 6.99178 6.16256 6.99178Z",
    fill: "#9D480A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16255 8.3998C5.92509 8.3998 5.73853 8.20758 5.73853 7.97578C5.73853 7.74398 5.93075 7.55176 6.16255 7.55176C6.39435 7.55176 6.58657 7.74398 6.58657 7.97578C6.58657 8.20758 6.4 8.3998 6.16255 8.3998Z",
    fill: "#9D480A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.464bc767386f4c38d7b3a017aab2fe4d.svg";
export { ForwardRef as ReactComponent };